import React, { useState, useEffect } from "react";
import './css/faq.css'

const FAQ = () => {
    return (
        <section className="strengthenView home-faq">
            <div className="container">
                <div className="row align-items-center">
                <div className="col-md-12 col-lg-12 text-center">
                    <h2 className="h1">Frequently Asked Questions</h2>
                </div>

                <div className="col-md-12">
                    <div className="acc-container">
                    <div className="accordion" id="accordionFaqExample">

                        
                        <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="headingGrantManagement"
                        >
                            <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseGrantManagement"
                            aria-expanded="true"
                            aria-controls="collapseGrantManagement"
                            >
                            What is Right Cause nonprofit software?
                            </button>
                        </h2>

                        <div
                            id="collapseGrantManagement"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingGrantManagement"
                            data-bs-parent="#accordionFaqExample"
                        >
                            <div className="accordion-body">
                            Right Cause is a cloud-based platform built for nonprofits, helping organizations manage fundraising, donor relationships, grants, volunteers, and reporting from one central system instead of juggling separate spreadsheets and tools.
                            </div>
                        </div>
                        </div>

                        <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="headingApplicationManagement"
                        >
                            <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseApplicationManagement"
                            aria-expanded="false"
                            aria-controls="collapseApplicationManagement"
                            >
                            How does Right Cause help nonprofits improve fundraising?
                            </button>
                        </h2>

                        <div
                            id="collapseApplicationManagement"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingApplicationManagement"
                            data-bs-parent="#accordionFaqExample"
                        >
                            <div className="accordion-body">
                            It helps you track donations, manage campaigns, segment supporters, and measure results, which makes it easier to grow donor engagement and overall fundraising performance over time. 
                            </div>
                        </div>
                        </div>

                        <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="headingDonorProspecting"
                        >
                            <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseDonorProspecting"
                            aria-expanded="false"
                            aria-controls="collapseDonorProspecting"
                            >
                            Can Right Cause manage grants and donor information in one system? 
                            </button>
                        </h2>

                        <div
                            id="collapseDonorProspecting"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingDonorProspecting"
                            data-bs-parent="#accordionFaqExample"
                        >
                            <div className="accordion-body">
                            They're combined. Right Cause brings grant management, donor management, fundraising, and stakeholder engagement into a single platform, which cuts down on manual work and gives you better visibility across all your programs. 
                            </div>
                        </div>
                        </div>

                        <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="headingGrantReceives"
                        >
                            <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseGrantReceives"
                            aria-expanded="false"
                            aria-controls="collapseGrantReceives"
                            >
                            Is Right Cause built on Microsoft technology? 
                            </button>
                        </h2>

                        <div
                            id="collapseGrantReceives"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingGrantReceives"
                            data-bs-parent="#accordionFaqExample"
                        >
                            <div className="accordion-body">
                            Yes, it lives within the Microsoft ecosystem and integrates with tools like Dynamics 365, Power Platform, Azure, and Dataverse. 
                            </div>
                        </div>
                        </div>

                        <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="headingGrantSummary"
                        >
                            <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseGrantSummary"
                            aria-expanded="false"
                            aria-controls="collapseGrantSummary"
                            >
                            Who can benefit from using Right Cause?
                            </button>
                        </h2>

                        <div
                            id="collapseGrantSummary"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingGrantSummary"
                            data-bs-parent="#accordionFaqExample"
                        >
                            <div className="accordion-body">
                            Nonprofits of all sizes, including charities, healthcare organizations, community groups, educational institutions, membership associations, and foundations. 
                            </div>
                        </div>
                        </div>

                    </div>
                    </div>
                </div>
                </div>
            </div>
            </section>
    )
}

export default FAQ